import React from "react";
import { MapPin } from "lucide-react";

const AREAS = [
  { name: "Medford", note: "Headquarters", featured: true },
  { name: "Ashland", note: "Free travel" },
  { name: "Grants Pass", note: "Free travel" },
  { name: "Central Point", note: "Free travel" },
  { name: "Jacksonville", note: "Free travel" },
  { name: "Phoenix", note: "Free travel" },
  { name: "Talent", note: "Free travel" },
  { name: "Eagle Point", note: "Free travel" },
  { name: "White City", note: "Free travel" },
  { name: "Shady Cove", note: "Travel fee may apply" },
  { name: "Gold Hill", note: "Travel fee may apply" },
  { name: "Rogue River", note: "Travel fee may apply" },
];

const MAP_SRC =
  "https://www.openstreetmap.org/export/embed.html?bbox=-123.55%2C42.05%2C-122.45%2C42.95&layer=mapnik&marker=42.3265%2C-122.8756";

export default function ServiceArea() {
  return (
    <section id="area" data-testid="service-area-section" className="py-24 md:py-32 bg-slate-50 border-y border-slate-200">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-8 mb-16 items-end">
          <div className="md:col-span-7">
            <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-blue-600 mb-4">
              Mobile Service Area
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
              We come to you,<br />across Southern Oregon.
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-slate-600 leading-relaxed">
              Based in Medford, serving the entire Rogue Valley and beyond. We
              come to your home or office. We just need access to a working
              water spigot and a standard power outlet for our equipment.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-px bg-slate-200 border border-slate-200">
          <div className="lg:col-span-7 bg-white">
            <div className="relative h-[500px]" data-testid="service-area-map">
              <iframe
                title="Southern Oregon Detailing service area"
                src={MAP_SRC}
                className="absolute inset-0 w-full h-full grayscale-[15%] contrast-[1.05]"
                loading="lazy"
              />
              <div className="absolute top-5 left-5 bg-white p-4 border border-slate-200 max-w-[260px]">
                <div className="flex items-start gap-2">
                  <MapPin size={18} className="text-blue-600 mt-0.5" />
                  <div>
                    <div className="font-display font-black text-base tracking-tight">Medford, OR</div>
                    <div className="text-xs text-slate-600 mt-1">Headquarters · Serving the entire Rogue Valley</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 bg-white p-8 md:p-10">
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-blue-600 mb-6">Coverage areas</div>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-4">
              {AREAS.map((a) => (
                <li key={a.name} data-testid={`area-${a.name.toLowerCase().replace(/\s+/g, "-")}`} className="border-b border-slate-100 pb-3">
                  <div className="flex items-center gap-2">
                    <span className={`h-1.5 w-1.5 ${a.featured ? "bg-blue-600" : "bg-slate-300"}`} />
                    <span className="font-display font-bold text-base text-slate-900">{a.name}</span>
                  </div>
                  <div className="text-[11px] uppercase tracking-wider text-slate-500 mt-1 ml-3.5">{a.note}</div>
                </li>
              ))}
            </ul>

            <div className="mt-10 p-5 bg-slate-900 text-white">
              <div className="text-[10px] tracking-[0.3em] uppercase text-blue-400 font-bold mb-1">Outside this area?</div>
              <div className="text-sm text-slate-200">
                Give us a call.{" "}
                <a href="tel:5416222960" className="underline underline-offset-4 hover:text-blue-400">541-622-2960</a>
                . We're often willing to travel.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
